import { ElementType, useState } from 'react';
import { MoreVert } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { CustomMenu } from '@/components/common/CustomMenu';
import { theme } from '@/styles/theme';

export type TableRowAction = {
  title: string;
  icon: ElementType;
  onClick: () => void;
  onMouseEnter?: () => void;
  color?: 'primary' | 'error';
};

interface TableRowActionsProps {
  primaryAction?: TableRowAction;
  secondaryActions?: TableRowAction[];
}

export function TableRowActions({
  primaryAction,
  secondaryActions = [],
}: TableRowActionsProps) {
  const [menuElement, setMenuElement] = useState<null | HTMLElement>(null);
  const PrimaryActionIcon = primaryAction?.icon;

  if (!primaryAction && !secondaryActions.length) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      {primaryAction && PrimaryActionIcon && (
        <Tooltip title={primaryAction.title} disableInteractive>
          <IconButton
            onMouseEnter={primaryAction.onMouseEnter}
            onClick={(event) => {
              event.stopPropagation();
              return primaryAction.onClick();
            }}
            size="small"
            sx={{
              '&:hover': {
                color:
                  primaryAction.color === 'error'
                    ? theme.palette.error.main
                    : theme.palette.primary.main,
              },
            }}
          >
            <PrimaryActionIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {!!secondaryActions.length && (
        <>
          <Tooltip title="Mais ações" disableInteractive>
            <IconButton
              onMouseEnter={() => {
                secondaryActions.forEach((action) => action.onMouseEnter?.());
              }}
              onClick={(event) => {
                event.stopPropagation();
                return setMenuElement(event.currentTarget);
              }}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <MoreVert fontSize="small" />
            </IconButton>
          </Tooltip>
          <CustomMenu
            anchorEl={menuElement}
            onClose={() => setMenuElement(null)}
            menuItems={secondaryActions}
          />
        </>
      )}
    </Stack>
  );
}
